import { LessonActionListSchema, EvaluationSchema } from "@/lib/schemas/lessonAction";
import { LessonAction } from "@/harness/harness.types";

/**
 * Client-side AI service — calls the SAME-ORIGIN Pages Functions
 * (/api/lesson, /api/evaluate), never Mistral directly. Re-validates
 * the response against the shared schema even though the server
 * already did, since this is the boundary the rest of the app trusts.
 */
export async function requestLessonActions(topic: string, priorMistakes: string[] = []): Promise<LessonAction[]> {
  const res = await fetch("/api/lesson", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ topic, priorMistakes }),
  });

  if (!res.ok) {
    throw new Error(`Lesson request failed: ${res.status} ${await res.text()}`);
  }

  const json = await res.json();
  const parsed = LessonActionListSchema.safeParse(json);
  if (!parsed.success) {
    throw new Error("Lesson response failed client-side validation");
  }
  return parsed.data.actions;
}

export async function evaluateAnswer(question: string, answer: string) {
  const res = await fetch("/api/evaluate", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ question, answer }),
  });
  if (!res.ok) {
    throw new Error(`Evaluate request failed: ${res.status} ${await res.text()}`);
  }
  const parsed = EvaluationSchema.safeParse(await res.json());
  if (!parsed.success) {
    throw new Error("Evaluation response failed client-side validation");
  }
  return parsed.data;
}
